import Service, { getCallApiFunction } from '../service'

// Types
import { IMultiDropdownItem, MULTI_DROPDOWN_KEYS } from '@/types/system-dropdown/multi'

export type MultiDropdownResponse = {
  shopHomeFeatured: IMultiDropdownItem[]
}

interface IMultiDropdownParams {
  keys: MULTI_DROPDOWN_KEYS
}

class FetchMultiDropdownValueApi extends Service {
  constructor(params: IMultiDropdownParams) {
    super()
    this.name = 'FETCH_MULTI_DROPDOWN_VALUE'

    this.config = {
      url: `/v1/system/dropdown/multi`,
      method: 'GET',
      params,
    }
  }
}

export const fetchMultiDropdownValue = (params: IMultiDropdownParams): Promise<MultiDropdownResponse> =>
  getCallApiFunction(new FetchMultiDropdownValueApi(params))
